<template>
  <div
    class="container-fluid"
    style="background-color: white;width:100%; text-align:center;justify-content:center ;overflow-x: hidden;overflow-y: hidden;margin-top:0px;margin-bottom:100px;"
  >
    <div style="margin-top:-100px;background-color:white"></div>
    <img
      alt="Page Not found"
      src="../../assets/imgs/404.jpg"
      title="Sorry! Page Not Found"
      style="width:60%;height:70%"
    >
  </div>
</template>

<style  >
body.errorClass {
  background: none !important;
  /* padding-top: 10% !important;
  overflow-y: hidden; */
}
/* body {
  background: none !important;
  padding-top: 10% !important;
  overflow-y: hidden;
  padding-top: -100;
} */
</style>


 <script  >
// document.body.style.background = "none";
//
export default {
  beforeCreate: function() {
    debugger;
    if (this.$route.meta && this.$route.meta.class) {
      document.body.className = "errorClass";
      document.body.id = "errorClass";
    } else {
      document.body.className = "";
    }
  }
};
</script>


